// Spanish (generic region) translations for ag-Grid

export default {
    // Set Filter
    selectAll: '(Seleccionar todo)',
    selectAllSearchResults: '(Seleccionar todos los resultados de búsqueda)',
    searchOoo: 'Buscar...',
    blanks: '(En blanco)',
    noMatches: 'No hay coincidencias',

    // Number Filter & Text Filter
    filterOoo: 'Filtrar...',
    equals: 'Igual a',
    notEqual: 'Distinto de',
    empty: 'Elegir uno',

    // Number Filter
    lessThan: 'Menor que',
    greaterThan: 'Mayor que',
    lessThanOrEqual: 'Menor o igual que',
    greaterThanOrEqual: 'Mayor o igual que',
    inRange: 'En el rango',
    inRangeStart: 'hasta',
    inRangeEnd: 'desde',

    // Text Filter
    contains: 'Contiene',
    notContains: 'No contiene',
    startsWith: 'Comienza con',
    endsWith: 'Termina con',

    // Date Filter
    dateFormatOoo: 'aaaa-mm-dd',

    // Filter Conditions
    andCondition: 'Y',
    orCondition: 'O',

    // Filter Buttons
    applyFilter: 'Aplicar',
    resetFilter: 'Restablecer',
    clearFilter: 'Limpiar',
    cancelFilter: 'Cancelar',

    // Filter Titles
    textFilter: 'Filtro de texto',
    numberFilter: 'Filtro de número',
    dateFilter: 'Filtro de fecha',
    setFilter: 'Filtro de conjunto',

    // Side Bar
    columns: 'Columnas',
    filters: 'Filtros',

    // columns tool panel
    pivotMode: 'Modo pivote',
    groups: 'Grupos de filas',
    rowGroupColumnsEmptyMessage: 'Arrastre aquí para establecer grupos de filas',
    values: 'Valores',
    valueColumnsEmptyMessage: 'Arrastre aquí para agregar',
    pivots: 'Etiquetas de columna',
    pivotColumnsEmptyMessage: 'Arrastre aquí para establecer etiquetas de columna',

    // Header of the Default Group Column
    group: 'Grupo',

    // Other
    loadingOoo: 'Cargando...',
    noRowsToShow: 'No hay filas para mostrar',
    enabled: 'Habilitado',

    // Menu
    pinColumn: 'Fijar columna',
    pinLeft: 'Fijar a la izquierda',
    pinRight: 'Fijar a la derecha',
    noPin: 'Sin fijar',
    valueAggregation: 'Agregación de valores',
    autosizeThiscolumn: 'Autoajustar esta columna',
    autosizeAllColumns: 'Autoajustar todas las columnas',
    groupBy: 'Agrupar por',
    ungroupBy: 'Desagrupar por',
    resetColumns: 'Restablecer columnas',
    expandAll: 'Expandir todo',
    collapseAll: 'Cerrar todo',
    copy: 'Copiar',
    ctrlC: 'Ctrl+C',
    copyWithHeaders: 'Copiar con encabezados',
    paste: 'Pegar',
    ctrlV: 'Ctrl+V',
    export: 'Exportar',
    csvExport: 'Exportar CSV',
    excelExport: 'Exportar Excel',

    // Enterprise Menu Aggregation and Status Bar
    sum: 'Suma',
    min: 'Mín',
    max: 'Máx',
    none: 'Ninguno',
    count: 'Cuenta',
    avg: 'Promedio',
    filteredRows: 'Filtradas',
    selectedRows: 'Seleccionadas',
    totalRows: 'Filas totales',
    totalAndFilteredRows: 'Filas',
    more: 'Más',
    to: 'a',
    of: 'de',
    page: 'Página',
    nextPage: 'Página siguiente',
    lastPage: 'Última página',
    firstPage: 'Primera página',
    previousPage: 'Página anterior',

    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: 'Gráfico dinámico y modo pivote',
    pivotChart: 'Gráfico dinámico',
    chartRange: 'Rango del gráfico',

    columnChart: 'Columna',
    groupedColumn: 'Agrupado',
    stackedColumn: 'Apilado',
    normalizedColumn: '100% apilado',

    barChart: 'Barra',
    groupedBar: 'Agrupado',
    stackedBar: 'Apilado',
    normalizedBar: '100% apilado',

    pieChart: 'Circular',
    pie: 'Circular',
    doughnut: 'Anillo',

    line: 'Línea',

    xyChart: 'X Y (Dispersión)',
    scatter: 'Dispersión',
    bubble: 'Burbuja',

    areaChart: 'Área',
    area: 'Área',
    stackedArea: 'Apilado',
    normalizedArea: '100% apilado',

    histogramChart: 'Histograma',

    // Charts
    pivotChartTitle: 'Gráfico dinámico',
    rangeChartTitle: 'Gráfico de rango',
    settings: 'Configuración',
    data: 'Datos',
    format: 'Formato',
    categories: 'Categorías',
    defaultCategory: '(Ninguno)',
    series: 'Series',
    xyValues: 'Valores X Y',
    paired: 'Modo emparejado',
    axis: 'Eje',
    navigator: 'Navegador',
    color: 'Color',
    thickness: 'Grosor',
    xType: 'Tipo X',
    automatic: 'Automático',
    category: 'Categoría',
    number: 'Número',
    time: 'Tiempo',
    xRotation: 'Rotación X',
    yRotation: 'Rotación Y',
    ticks: 'Marcas',
    width: 'Ancho',
    height: 'Alto',
    length: 'Longitud',
    padding: 'Relleno',
    spacing: 'Espaciado',
    chart: 'Gráfico',
    title: 'Título',
    titlePlaceholder: 'Título del gráfico - haga doble clic para editar',
    background: 'Fondo',
    font: 'Fuente',
    top: 'Arriba',
    right: 'Derecha',
    bottom: 'Abajo',
    left: 'Izquierda',
    labels: 'Etiquetas',
    size: 'Tamaño',
    minSize: 'Tamaño mínimo',
    maxSize: 'Tamaño máximo',
    legend: 'Leyenda',
    position: 'Posición',
    markerSize: 'Tamaño del marcador',
    markerStroke: 'Trazo del marcador',
    markerPadding: 'Relleno del marcador',
    itemSpacing: 'Espaciado de elementos',
    itemPaddingX: 'Relleno de elemento X',
    itemPaddingY: 'Relleno de elemento Y',
    layoutHorizontalSpacing: 'Espaciado horizontal',
    layoutVerticalSpacing: 'Espaciado vertical',
    strokeWidth: 'Ancho de trazo',
    offset: 'Desplazamiento',
    offsets: 'Desplazamientos',
    tooltips: 'Descripciones emergentes',
    callout: 'Llamada',
    markers: 'Marcadores',
    shadow: 'Sombra',
    blur: 'Desenfoque',
    xOffset: 'Desplazamiento X',
    yOffset: 'Desplazamiento Y',
    lineWidth: 'Ancho de línea',
    normal: 'Normal',
    bold: 'Negrita',
    italic: 'Cursiva',
    boldItalic: 'Negrita cursiva',
    predefined: 'Predefinido',
    fillOpacity: 'Opacidad de relleno',
    strokeOpacity: 'Opacidad de línea',
    histogramBinCount: 'Número de contenedores',
    columnGroup: 'Columna',
    barGroup: 'Barra',
    pieGroup: 'Circular',
    lineGroup: 'Línea',
    scatterGroup: 'X Y (Dispersión)',
    areaGroup: 'Área',
    histogramGroup: 'Histograma',
    groupedColumnTooltip: 'Agrupado',
    stackedColumnTooltip: 'Apilado',
    normalizedColumnTooltip: '100% apilado',
    groupedBarTooltip: 'Agrupado',
    stackedBarTooltip: 'Apilado',
    normalizedBarTooltip: '100% apilado',
    pieTooltip: 'Circular',
    doughnutTooltip: 'Anillo',
    lineTooltip: 'Línea',
    groupedAreaTooltip: 'Área',
    stackedAreaTooltip: 'Apilado',
    normalizedAreaTooltip: '100% apilado',
    scatterTooltip: 'Dispersión',
    bubbleTooltip: 'Burbuja',
    histogramTooltip: 'Histograma',
    noDataToChart: 'No hay datos disponibles para graficar.',
    pivotChartRequiresPivotMode: 'El gráfico dinámico requiere que el modo pivote esté habilitado.',
    chartSettingsToolbarTooltip: 'Menú',
    chartLinkToolbarTooltip: 'Vinculado a la cuadrícula',
    chartUnlinkToolbarTooltip: 'Desvinculado de la cuadrícula',
    chartDownloadToolbarTooltip: 'Descargar gráfico',

    // ARIA
    ariaHidden: 'oculto',
    ariaVisible: 'visible',
    ariaChecked: 'marcado',
    ariaUnchecked: 'desmarcado',
    ariaIndeterminate:'indeterminado',
    ariaColumnSelectAll: 'Alternar selección de todas las columnas',
    ariaInputEditor: 'Editor de entrada',
    ariaDateFilterInput: 'Entrada de filtro de fecha',
    ariaFilterInput: 'Entrada de filtro',
    ariaFilterColumnsInput: 'Entrada de filtro de columnas',
    ariaFilterValue: 'Valor de filtro',
    ariaFilterFromValue: 'Filtrar desde el valor',
    ariaFilterToValue: 'Filtrar hasta el valor',
    ariaFilteringOperator: 'Operador de filtrado',
    ariaColumnToggleVisibility: 'alternar visibilidad de columna',
    ariaColumnGroupToggleVisibility: 'alternar visibilidad de grupo de columnas',
    ariaRowSelect: 'Presione ESPACIO para seleccionar esta fila',
    ariaRowDeselect: 'Presione ESPACIO para deseleccionar esta fila',
    ariaRowToggleSelection: 'Presione Espacio para alternar la selección de fila',
    ariaRowSelectAll: 'Presione Espacio para alternar la selección de todas las filas',
    ariaSearch: 'Buscar',
    ariaSearchFilterValues: 'Buscar valores de filtro'
}